import {ProfilesState} from "./ProfilesState";

export const state: ProfilesState = {
    list: {}
}